import { ReactNode } from 'react';
import { useChartDimensions } from './useChartDimensions';

interface ResponsiveChartContainerProps {
    children: ReactNode;
    className?: string;
    minHeight?: number;
    maxHeight?: number;
    testId?: string;
}

export default function ResponsiveChartContainer({
    children,
    className = '',
    minHeight = 300,
    maxHeight = 700,
    testId = 'responsive-chart-container',
}: ResponsiveChartContainerProps) {
    const { height } = useChartDimensions();

    const clampedHeight = Math.min(Math.max(height, minHeight), maxHeight);

    return (
        <div
            className={`w-full ${className}`}
            style={{ height: `${clampedHeight}px` }}
            data-testid={testId}
        >
            {children}
        </div>
    );
}
